import './src/main.css';
import './src/theme.css';
import { initApp, initEffects } from './src/app.js';

document.addEventListener('DOMContentLoaded', () => {
    initApp();
    initEffects();

    // Lazy-load Three.js scenes - not needed for initial render
    const planetContainer = document.getElementById('planet-container');
    const starsContainer = document.getElementById('stars-container');

    if (planetContainer || starsContainer) {
        import('./src/space-scene.js').then(({ PlanetScene, StarsScene }) => {
            if (planetContainer) new PlanetScene(planetContainer);
            if (starsContainer) new StarsScene(starsContainer);
        });
    }
});
